// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"assets_i18n_en_translation_json":"ed0e3e8f73b352f36a1d","assets_i18n_nl_translation_json":"bcb1b0c7104b0d03f02e"}[chunkId] + ".chunk.js";
};